(function ($) {

    var enterState = true;

    ///////////////      INITIALIZATION     //////////////////////
    this.init = function () {

        initKeyNav();

        // EVENT HANDLING //

        // When you enter a level1 item - make sure we pop level 2 (and close all sibling level 2 menus)
        $(".mainnav .level1-item.haschildren").mouseenter(enterNav)
            .mouseleave(leaveNav);

        // When we enter a level1 item or any child within it, if we do not enter another child in that level1 item, close the nav
        $(".mainnav .level1-item.haschildren").focusin(enterNav)
            .focusout(leaveNav);

        // Level 1, 2, and 3 keyboard handler
        $(".mainnav").find(".level1-item-link, .level2-item-link, .level2-rightside-content-link").on("keydown", menuKeyNav);

        // make sure that the right key hits the next landmark
        $(".mainnav-content-right a").first().addClass("afternav");

        // Add an aria label to the first link
        $(".mainnav a").first().attr("aria-label", "Power FI Main Navigation. Press Tab to Move past Navigation. Press Right and Left Arrow Keys to navigate main sections. Press up and down to navigate between links inside sections");

        // Click on the nav section
        $(".globalheader-content-sectionnav a").on("click", clickSectionNav);

        //display active nav section 
        $(".mainnav-content-left-main").each(function () {
            if ($(this).data("sectionselect") === $(".globalnavselected").data("section")) {
                $(this).removeClass("mainnavhidden");
                $(this).addClass("mainnavshown");
            } else {
                $(this).addClass("mainnavhidden");
                $(this).removeClass("mainnavshown");
            }
        });

        //if there is no active nav section
        if ($(".globalnavselected").data("section") == null) {
            $(".globalheader-content-sectionnav ul>li:first-child a").click();
        }

        //Handle overlay
        $(".mainnavshown").on("mouseenter", function () {
            showOverlay();
        });

        $(".mainnavshown").on("mouseleave", function () {
            hideOverlay();
        });

        $(".mainnav").on("focusin", function () {
            showOverlay();
            hideOverlay();
        });
    };

    ///////////////      SECTION NAV        ///////////////////////
    function clickSectionNav(event) {
        // okay here we go
        var section = $(this).data("section");

        if (section) {
            $(".mainnav-content-left-main").each(function () {
                if ($(this).data("sectionselect") === section) {
                    $(this).removeClass("mainnavhidden");
                } else {
                    $(this).addClass("mainnavhidden");
                }
            });
        }
    }

    ///////////////      KEYBOARD NAV      ///////////////////////
    function initKeyNav() {
        var that,
            y = 0;

        $(".mainnav .level1-item").each(function (i) {
            that = this;
            $(this).find(".level1-item-link").attr("nav-index-x", i).attr("nav-index-y", y);
            y++;

            $(this).find(".level2-item-link").each(function () {
                $(this).attr("nav-index-x", i).attr("nav-index-y", y);
                y++;
            });

            $(this).find(".level2-rightside-content-link").each(function () {
                $(this).attr("nav-index-x", i).attr("nav-index-y", y);
                y++;
            });

            y = 0;
        });
    }
    function menuKeyNav(event) {

        var $item, itemX, itemY;

        stopThaProp(event);

        $item = $(event.currentTarget);
        itemX = $(event.currentTarget).attr("nav-index-x") - 0;
        itemY = $(event.currentTarget).attr("nav-index-y") - 0;

        switch (event.originalEvent.which) {
            case 37:
                // left
                if (itemX > 0) {
                    $(".mainnav").find('[nav-index-x="' + (itemX - 1) + '"][nav-index-y="0"]').focus();
                }
                break;
            case 38:
                // up 
                if (itemY > 0) {
                    $(".mainnav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + (itemY - 1) + '"]').focus();
                }
                event.preventDefault();

                break;
            case 39:
                // right
                $(".mainnav").find('[nav-index-x="' + (itemX + 1) + '"][nav-index-y="0"]').focus();
                break;
            case 40:
                // down 
                $(".mainnav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + (itemY + 1) + '"]').focus();
                event.preventDefault();
                break;
            case 9:
                // tab
                if (typeof event.originalEvent === "object" && event.originalEvent.shiftKey) {
                    $(".mainnav-content-left-homelink").focus();
                } else {
                    $(".afternav").focus();
                }
                event.preventDefault();
                break;
        }
    }



    //////////////        FOCUS HANDLING   ///////////////////////
    function enterNav(event) {
        closeLevel2();
        openLevel2(event);
    }
    function leaveNav() {
        closeLevel2();

    }
    function openLevel2(event) {
        if ($(event.currentTarget).hasClass("level1-item")) {
            $(event.currentTarget).find(".level1-item-link.haschildren-a").attr("aria-expanded", "true");
            $(event.currentTarget).find(".level2").addClass("level2-visible").removeClass("level2-hidden");
        } else {
            $(event.currentTarget).parents(".level1-item").find(".level2").addClass("level2-visible").removeClass("level2-hidden");
        }
    }
    function closeLevel2() {
        $(".mainnav").find(".level1-item-link[aria-expanded=true]").attr("aria-expanded", "false");
        $(".mainnav .level2-visible").addClass("level2-hidden").removeClass("level2-visible");
    }

    function showOverlay() {
        if (!$("body").hasClass("has-body-overlay") && $(".level2").hasClass("level2-visible")) {
            $("body").addClass("has-body-overlay");
        }
    }

    function hideOverlay() {
        if (!$(".level2").hasClass("level2-visible")) {
            $("body").removeClass("has-body-overlay");
        }
    }

    //////////////       UTILITY       ///////////////////////
    function stopThaProp(event) {
        event.stopPropagation();
    }

    this.init();

})(jQuery);

